import { HStack, FormRow } from '@cad-arc';
import { FormInput } from '../../../../forms/integrated-form-controls/form-input';
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { EventPanelFormType, EventPanelOptions } from '@mark43/cad-api';
import { DrugsBaseKey } from '../types';
import { FormSelect } from '../../../../forms/integrated-form-controls/form-select';
import { FormCheckbox } from '../../../../forms/integrated-form-controls/form-checkbox';
import { FormTextarea } from '../../../../forms/integrated-form-controls/form-text-area';
import { FormNumberInput } from '../../../../forms/integrated-form-controls/form-number-input';

export function EventPanelFormDrugsPropertyInputs(props: {
    form: UseFormReturn<EventPanelFormType>;
    index: number;
    baseKey: DrugsBaseKey;
    eventPanelOptions: EventPanelOptions;
    showExtraFields: boolean;
    isPersisted: boolean;
}) {
    const {
        form: eventForm,
        index,
        baseKey,
        showExtraFields,
        eventPanelOptions,
        isPersisted,
    } = props;

    return (
        <>
            <FormRow>
                <FormSelect
                    length="md"
                    control={eventForm.control}
                    label="Drug Category"
                    options={eventPanelOptions.drugCategoryOptions}
                    name={`${props.baseKey}.${index}.drugCategory`}
                    asEditable={!!isPersisted}
                    eventNotificationName="DRUGS_DRUG_CATEGORY"
                />
                <HStack marginTop={4} width={150}>
                    <FormCheckbox
                        label="Is Precursor Chemical?"
                        name={`${baseKey}.${index}.isPrecursorChemical`}
                        control={props.form.control}
                        asEditable={false}
                        length="md"
                        size="sm"
                        eventNotificationName="DRUGS_IS_PRECURSOR_CHEMICAL"
                    />
                </HStack>
            </FormRow>
            <FormRow>
                <FormNumberInput
                    numberInputProps={{ precision: 0 }}
                    length="md"
                    control={eventForm.control}
                    label="Quantity"
                    name={`${baseKey}.${index}.quantity`}
                    asEditable={!!isPersisted}
                />
                <FormSelect
                    length="md"
                    control={eventForm.control}
                    label="Measurement Units"
                    options={eventPanelOptions.measurementUnitsOptions}
                    name={`${props.baseKey}.${index}.measurementUnits`}
                    asEditable={!!isPersisted}
                    eventNotificationName="DRUGS_MEASUREMENT_UNITS"
                />
            </FormRow>
            <FormTextarea
                control={eventForm.control}
                label="Description"
                name={`${props.baseKey}.${index}.description`}
                length="md"
                asEditable={!!isPersisted}
                eventNotificationName="DRUGS_DESCRIPTION"
            />
            {showExtraFields ? (
                <>
                    <FormRow>
                        <FormSelect
                            control={eventForm.control}
                            label="Identifier Type"
                            name={`${props.baseKey}.${index}.identifierType`}
                            length="md"
                            options={eventPanelOptions.itemIdentifierOptions}
                            asEditable={!!isPersisted}
                            eventNotificationName="DRUGS_IDENTIFIER_TYPE"
                        />
                        <FormInput
                            control={eventForm.control}
                            label="Identifier"
                            name={`${props.baseKey}.${index}.identifier`}
                            length="md"
                            asEditable={!!isPersisted}
                            eventNotificationName="DRUGS_IDENTIFIER"
                        />
                    </FormRow>
                </>
            ) : undefined}
        </>
    );
}
